// Energinets farver som tal til Pixi. Brandfarverne kommer fra src/brand.ts (samme kilde som
// src/ui/tokens.css); her står kun kortets egne, afledte toner. Rød bruges kun til udfald, brud og mørkeure.
import { BRAND, hexToNum } from '../brand';

export const C = {
  green: hexToNum(BRAND.green),
  yellow: hexToNum(BRAND.yellow),
  orange: hexToNum(BRAND.orange),
  red: hexToNum(BRAND.red),
  turquoise: hexToNum(BRAND.turquoise),
  petrol: hexToNum(BRAND.petrol),
  ink: hexToNum(BRAND.ink),
  paper: hexToNum(BRAND.paper),
  contrast: hexToNum(BRAND.greenDark),
  white: hexToNum(BRAND.white),
  // Afledte, bløde toner til kort og figurer.
  sea: 0xc4e7e6,
  seaDeep: 0xb7e2e1,
  seaShallow: 0xdcf3f1,
  land: 0xeaf5e8,
  landEdge: 0xffffff,
  // Landpladens kant og den lyse rand ovenpå.
  landSide: 0x8cc4b0,
  landRim: 0xffffff,
  grass: 0x9fd8c4,
  tree: 0x3fb59b,
  treeDark: 0x2c9a82,
  wallWarm: 0xfff7ea,
  wallDark: 0xb9c6d0,
  windowDark: 0x4a5d70,
  cloud: 0x8fa0b1,
  cloudLight: 0xb9c7d4,
  // Kunstens materialer, navngivet så samme tone ikke står rå flere steder.
  wood: 0x8b7a62, // pæle, master, skilte
  concrete: 0xdfe7ec, // fundamenter, beton, hjulnav
  steel: 0xa9bcc7,
  metal: 0x8a9aa8,
  facade: 0xdfe9ee,
  facadeLight: 0xe4eef2,
  hall: 0xe8f1f4,
  stoneDim: 0xc5d0d8, // slukket mur og byggestøv
  windowUnlit: 0x50657a,
  roofUnlit: 0x5f7480,
  dusk: 0x6d7f90, // toner mod mørke, når lyset er gået
  sand: 0xc9b79a,
  smoke: 0xdde6eb,
  drop: 0x9fdcea,
  skin: 0xf6c9b8,
  glowWarm: 0xffe58a,
  sparkWarm: 0xffe6a8,
} as const;

export const CSS = {
  green: BRAND.green,
  yellow: BRAND.yellow,
  orange: BRAND.orange,
  red: BRAND.red,
  turquoise: BRAND.turquoise,
  petrol: BRAND.petrol,
  ink: BRAND.ink,
  paper: BRAND.paper,
  contrast: BRAND.greenDark,
} as const;

/** Lineær blanding af to farver (0..1). */
export function mix(a: number, b: number, t: number): number {
  const k = Math.max(0, Math.min(1, t));
  const ar = (a >> 16) & 255;
  const ag = (a >> 8) & 255;
  const ab = a & 255;
  const br = (b >> 16) & 255;
  const bg = (b >> 8) & 255;
  const bb = b & 255;
  return (Math.round(ar + (br - ar) * k) << 16) | (Math.round(ag + (bg - ag) * k) << 8) | Math.round(ab + (bb - ab) * k);
}

/** Belastning i promille til farve: grøn, gul, orange. Aldrig rød; rød er kun brud. */
export function loadColor(loadPm: number): number {
  if (loadPm <= 550) return C.green;
  if (loadPm <= 850) return mix(C.green, C.yellow, (loadPm - 550) / 300);
  return mix(C.yellow, C.orange, (loadPm - 850) / 150);
}
